import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { TrackAndTrace } from './track-and-trace.model';
import { Railcar } from '../railcar/railcar.model';
import { TrackAndTraceResult } from './track-and-trace-result.model';
import { TrackAndTraceRequest } from './track-and-trace-request.model';
import { OnDemandTraceRequest } from '../track-and-trace/on-demand-trace-request.model';

@Injectable({providedIn: 'root'})
export class TrackAndTraceService {
	private url: string;
	private allData = new ReplaySubject<TrackAndTrace[]>(1);

	constructor(private httpClient: HttpClient) {
		this.url = '/api/trackandtrace';	// "api/trackandtrace/..." URL calling RailincService APIs. while "/api/railinc/..." URLs caliing Rail360 APIs
	}

	public getById(traceRequestId: number): Observable<TrackAndTrace> {
		return this.httpClient.get<TrackAndTrace>(this.url + '/getById/' + traceRequestId);
	}

	public getLatestTraceResultsByTraceRequestIds(traceRequestIds: number[]): Observable<TrackAndTrace[]> {
		return this.httpClient.post<TrackAndTrace[]>('api/railinc/getLatestTraceResultsByTraceRequestIds/', traceRequestIds);
	}

	public getAll(refreshData: boolean): Observable<TrackAndTrace[]> {
		if(refreshData){
			this.allData =  new ReplaySubject<TrackAndTrace[]>(1);
		}
		if (!this.allData.observers.length || refreshData) {
			this.httpClient.get<TrackAndTrace[]>(this.url).subscribe( 	
				data => this.allData.next(data),
				error => {
					this.allData.error(error);
					this.allData = new ReplaySubject(1);
				}
			);
		}
		return this.allData;
	}

	public getInactiveTraces(): Observable<TrackAndTrace[]> {
		return this.httpClient.get<TrackAndTrace[]>(this.url + '/getInactiveTraces/');
	}

	public getByDate(date: Date, railcars: Railcar[]): Observable<TrackAndTraceResult[]> {
		return this.httpClient.post<TrackAndTraceResult[]>(this.url + '/getByDate?date=' + date.toLocaleDateString(), railcars);
	}

	public saveTraceExpirationDate(traceRequestIds: number[], traceExpirationDate: Date, isInactiveTraces: boolean): Observable<TrackAndTrace[]> {
		return this.httpClient.post<TrackAndTrace[]>(this.url + '/ExtendTrace?traceExpirationDate='+ traceExpirationDate.toLocaleDateString() + '&isInactiveTraces=' + isInactiveTraces, traceRequestIds);
	 }
	
	public expireTrace(traceRequestIds: number[]): Observable<any> {
		return this.httpClient.post<any>(this.url + '/ExpireTrace', traceRequestIds);
	}

	public runOnDemandTrace(onDemandTraceRequest: OnDemandTraceRequest): Observable<TrackAndTraceResult[]> {
		return this.httpClient.post<TrackAndTraceResult[]>('api/railinc/onDemandTrace', onDemandTraceRequest);
	}

	public startNewTracesForRailcars(trackAndTraceRequest: TrackAndTraceRequest, scheduleId: number = null): Observable<any> {
		if (scheduleId ==  null) {
			return this.httpClient.post<any>('/api/railinc/StartNewTracesForRailcars', trackAndTraceRequest);
		} else {
			return this.httpClient.post<any>('/api/railinc/StartNewTracesForRailcars?scheduleId=' + scheduleId, trackAndTraceRequest);
		}	
	}

	public getTraceRequestsByScheduleId(scheduleId: number): Observable<any> {
		return this.httpClient.get<any>(this.url + '/getTraceRequestsByScheduleId?scheduleId=' + scheduleId);
	}

	public expireTraceRequestsByScheduleId(scheduleId: number): Observable<any> {
		return this.httpClient.delete<any>(this.url + '/expireTraceRequestsByScheduleId?scheduleId='+ scheduleId);
	}
}
